import { Stack, Typography } from '@mui/material';
import logo from 'assets/images/logo.png';

const LogoMain = ({ keepATS }) => {
  return (
    <Stack direction="row" gap={1} alignItems="center">
      <img src={logo} alt="ClearSource ATS" width="170" />
      {keepATS && (
        <Typography variant="h3" sx={{ lineHeight: 0, mb: '-1px' }}>
          ATS
        </Typography>
      )}
    </Stack>
  );
};

export default LogoMain;
